class InsuranceManual {
    constructor(active, commissionValue, insurance) {
        this.active = active
        this.commissionValue = commissionValue
        this.insurance = insurance
    }

    static fromJson({ active, commissionValue, insurance }) {
        return new InsuranceManual(active, commissionValue, insurance)
    }
}

export default InsuranceManual
